module.exports = __webpack_public_path__ + "static/media/InstrumentSans-Regular.30388e86.woff2";